import { ITrimEditorManagerBase } from '../trim-editor.manager';
import { TrimUiManager } from '../ui/trim.ui.manager';
import { TrimPrint, TrimPrintManager } from '../../print/trim.print';
import { TrimImageEditManager } from '../image-edit/trim.image-edit.manager';
import { TrimDataManager } from '../data/trim-data.manager';
import { WH } from '../../../utilities/pixel-converter';
import { ApiGetTemplates } from '../../../api/sift/back/api-templates';
import { store } from '../../../app/store';
import { apiActions } from '../../../slices/api-slice';
import { ThumbCreatorManager } from './thumb-creator/thumb.creator.manager';
import { dialogActions } from '../../../components/dialog/slice/dialog-slice';
import { XmlParser } from '../../../manager/xml-parser';
import { TrimTempModel } from '../../model/trim.temp-model';
import { Env } from '../../../models/env';
import { TemplatesResponse } from '../../../models/api/sift/back/api-templates';
import { PrintDataStructure, PrintItemDataEntity } from '../../../models/sift/json/print-model';
import { NO_EDGE_TYPE } from '../image-edit/frame/trim.frame-controller';
import { TrimCjContainer } from '../../model/cj-factory';
import { CjStage } from '../../../layout-editor/model/cj-factory';
import { TrimCjTool } from '../../../utilities/trim.cj-tool';

type Option = {
  quality: number,
  scale: number
}
type Pos = {
  x: number,
  y: number
}

export type ThumbRequestParam = {
  kijshopCd: string,
  shopOrderId: string,
  orderId: string,
  editableImgId: string,
  item: PrintItemDataEntity,
  directFlg: '1' | '2',
  isCompThumb?: boolean,
};

export class TrimThumbManager implements ITrimEditorManagerBase {
  constructor() {
  }

  initialize(): void {}

  destroy(): void {}

  di(): void {}
  makeThumbInCanvas(canvas: HTMLCanvasElement, container: TrimCjContainer, printMng: TrimPrintManager): string {
    const print = printMng.currentPrint;
    const base = print?.base;
    const template = print?.base.getImageWindow();
    if (!base || !print || !template) {
      return '';
    }
    const fills = base.getFillWindow();
    const edgeTmp = printMng.getEdge(template.virtual.wh, fills);
    // NOTE: フチなしの商品と白フチ商品の判別がテンプレートではできないためハードコーディング
    const isNoEdge = print.item.productData?.meta?.borderType === NO_EDGE_TYPE;

    const renderCanvas = document.createElement('canvas');
    renderCanvas.width = canvas.width;
    renderCanvas.height = canvas.height;
    const stage = new CjStage(renderCanvas);
    stage.addChild(container);
    stage.update();
    const url = this.makeThumb(
      renderCanvas,
      {
        // width: edgeTmp ? edgeTmp.virtual.wh.width : template.virtual.wh.width,
        // height: edgeTmp ? edgeTmp.virtual.wh.height : template.virtual.wh.height,
        width: isNoEdge ? template.virtual.wh.width : template.virtual.wh.width + (template.virtual.pos.x * 2),
        height: isNoEdge ? template.virtual.wh.height : template.virtual.wh.height + (template.virtual.pos.y * 2),
      },
      {x: TrimImageEditManager.STAGE_CONTAINER_X + (isNoEdge ? template.virtual.pos.x : 0), y: TrimImageEditManager.STAGE_CONTAINER_Y + (isNoEdge ? template.virtual.pos.y : 0)},
      )
    // makeThumbの処理が終わってから圧殺するように念の為少しだけラグをかけておく
    setTimeout(() => {
      renderCanvas.width = 0;
      renderCanvas.height = 0;
    }, 100);
    return url
  }

  async makeThumbOutCanvas(param: ThumbRequestParam): Promise<string | undefined> {
    const { kijshopCd, shopOrderId, orderId, editableImgId, item, directFlg, isCompThumb} = param;
    const canvas = document.createElement('canvas');

    const printMng = new TrimPrintManager();
    const temp = await this.loadTemplate(param);
    // const temp = item.template ?? await this.loadTemplate(param);

    const showAlert = () => {
      store.dispatch(dialogActions.pushMessage({
        title: '確認',
        message: ['サムネイルの生成に失敗しました'],
        buttons: [{
          label: 'OK',
          callback: () => {
            store.dispatch(dialogActions.pop());
          },
        }],
        id: 'print:thumb-alert'
      }));
    }
    if (!temp) {
      showAlert();
      return;
    }
    await printMng.create({kijshopCd, shopOrderId, orderId, temp, editableImgId, item, structure: undefined, isThumbCreate: true});
    const print = printMng.currentPrint;
    const base = print?.base;
    const template = print?.base.getImageWindow();
    if (!base || !print || !template) {
      showAlert();
      return;
    }
    const fills = base.getFillWindow();
    const edgeTmp = printMng.getEdge(template.virtual.wh, fills);
    // NOTE: フチなしの商品と白フチ商品の判別がテンプレートではできないためハードコーディング
    const isNoEdge = print.item.productData?.meta?.borderType === NO_EDGE_TYPE;
    const thumbCreatorManager = new ThumbCreatorManager(canvas);
    await thumbCreatorManager.initStage({...param, printMng});
    const url = this.makeThumb(
      canvas,
      {
        // width: edgeTmp ? edgeTmp.virtual.wh.width : template.virtual.wh.width,
        // height: edgeTmp ? edgeTmp.virtual.wh.height : template.virtual.wh.height,
        width: isNoEdge ? template.virtual.wh.width : template.virtual.wh.width + (template.virtual.pos.x * 2),
        height: isNoEdge ? template.virtual.wh.height : template.virtual.wh.height + (template.virtual.pos.y * 2),
      },
      {x: thumbCreatorManager.STAGE_CONTAINER_X + (isNoEdge ? template.virtual.pos.x : 0), y: thumbCreatorManager.STAGE_CONTAINER_Y + (isNoEdge ? template.virtual.pos.y : 0)},
    )
    thumbCreatorManager.destroy();
    canvas.width = 0;
    canvas.height = 0;
    return url
  }

  private loadTemplate = (requestParam: ThumbRequestParam) => new Promise<TrimTempModel | null>((resolve) => {
    const { item, editableImgId, directFlg} = requestParam;

    const getTemplate = (itemId: string, directFlg: '1' | '2', printDateFlg: boolean) => {
      if (!item) throw new Error('対象の商品が存在しません。');
      const _templates = item.templates;
      const templates = _templates?.filter(v => !!Number(v.printDateFlg) === !!printDateFlg);
      const target = !directFlg
        ? templates?.[0]
        : templates?.find((v) => v.directFlg === directFlg) ?? templates?.[0];
      if (!target) throw new Error('対象のテンプレートが存在しません。');
      return target;
    }

    const image = item.images.find(v => v.id === editableImgId);
    if (!image) {
      resolve(null);
      return;
    }
    const printDateFlg = !!image.datePrint;
    const template = getTemplate(item.id, directFlg, printDateFlg);
    if (template) {
      resolve(template.template);
    } else {
      resolve(null);
    }

    // const itemId = item.productData?.ProductDetailItemData?.itemId ?? '';
    // const edgeDtempId = item.productData?.meta?.borderType;
    // const BASE_URL = `${Env.api.back.protocol}://${Env.api.back.host}/templates`;
    // store.dispatch(apiActions.run(new ApiGetTemplates({itemId, edgeDtempId, directFlg: Number(directFlg)}), {
    //   onSuccess: (res) => {
    //     const data = res.body.data as TemplatesResponse;
    //     const target = data.templateGroupData.find((v) => v.directFlg === directFlg);
    //     if (!target) {
    //       console.error('template not found !!!!');
    //       resolve(null)
    //       return;
    //     };
    //     console.log(BASE_URL);
    //     return fetch(
    //       `${BASE_URL}/${target.hpsTppath}/template.xml`,
    //       { method: 'GET', mode: 'cors' },
    //     ).then(res => res.text())
    //       .then(async (body) => {
    //         console.log(body);
    //         const temp = await new XmlParser().parse<TrimTempModel>(body);
    //         resolve(temp)
    //       });
    //   },
    // }))
  });

  makeThumb(canvas: HTMLCanvasElement, size: WH, clopPos: Pos, option: Option = {quality: 0.8, scale: 0.5}): string {
    const {quality, scale} = option;
    const format = 'image/jpeg';

    // ← その場で作る
    const thumbCanvas = document.createElement('canvas');
    const ctx = thumbCanvas.getContext('2d');
    if (!ctx) throw new Error('Failed to get canvas ctx');

    const w = size.width;
    const h = size.height;
    thumbCanvas.width = w * scale;
    thumbCanvas.height = h * scale;

    ctx.drawImage(canvas, clopPos.x, clopPos.y, w, h, 0, 0, w * scale, h * scale);
    const url = thumbCanvas.toDataURL(format, quality);

    // ← 即破棄
    thumbCanvas.width = 0;
    thumbCanvas.height = 0;

    return url;
  }

}
